import { useSelector } from 'react-redux'
import * as R from 'ramda'

import { useExportResourceModal } from 'components/modals/common/ExportResourceModal/hooks'
import { useModal } from 'hooks'
import { getFileName } from 'utils/sheet'

export const useExportJobsData = () => {
  const { projects } = useSelector(state => state.orm)

  const fileName = getFileName('jobs')

  const pks = R.keys(projects?.meta?.selected) || []

  const data = R.pipe(
    R.pick(pks),
    R.values,
    R.map(
      R.pick([
        'name',
        'description',
        'candidates_count',
        'languages',
        'start_date',
        'end_date',
      ]),
    ),
  )(projects?.items)

  const { handleExportFile } = useExportResourceModal({ data })

  const handleExportCSV = handleExportFile(`${fileName}.csv`)

  const handleExportXLXS = handleExportFile(`${fileName}.xlsx`)

  return {
    state: { data },
    handlers: { handleExportCSV, handleExportXLXS },
  }
}

export const useExportJobsModal = () => {
  const { handleClose, handleOpen, isOpen } = useModal()

  return {
    handleExportJobsModalClose: handleClose,
    handleExportJobsModalOpen: handleOpen,
    isExportJobsModalOpen: isOpen,
  }
}
